import React, { useState } from "react";
import { Box } from "@mui/material";
import CodeOutlined from "@mui/icons-material/CodeOutlined";
import {
  ApiDocCreateOrder,
  ApiDocCreateReceiveOrder,
  ApiDocGetTransaction,
  ApiDocGetBalance,
  ApiDocCreateApeal,
  ApiDocAttachFile,
  ApiDocWebHook,
  ApiDocConfirm,
} from "../components/Documentation";
import EndpointCard, { HttpVerb } from "../components/EndpointCard";
import { PageHeader } from "../components";

/** The whole reference is described here; each entry renders one endpoint card. */
const ENDPOINTS: {
  id: string;
  title: string;
  verb: HttpVerb;
  path: string;
  content: React.ReactNode;
}[] = [
  {
    id: "payin",
    title: "Payment creation",
    verb: "POST",
    path: "{base_url}/api/v1/payments/deposit",
    content: <ApiDocCreateReceiveOrder />,
  },
  {
    id: "payout",
    title: "Payout",
    verb: "POST",
    path: "{base_url}/api/v1/payments/payout",
    content: <ApiDocCreateOrder />,
  },
  {
    id: "appeal",
    title: "Appeal creation",
    verb: "POST",
    path: "{base_url}/api/v1/payments/create_appeal",
    content: <ApiDocCreateApeal />,
  },
  {
    id: "file",
    title: "Attach appeal file",
    verb: "POST",
    path: "{base_url}/api/v1/payments/appeal_file",
    content: <ApiDocAttachFile />,
  },
  {
    id: "balance",
    title: "Balance",
    verb: "GET",
    path: "{base_url}/api/v1/info/balance",
    content: <ApiDocGetBalance />,
  },
  {
    id: "status",
    title: "Check order status",
    verb: "GET",
    path: "{base_url}/api/v1/info/check_order",
    content: <ApiDocGetTransaction />,
  },
  {
    id: "webhook",
    title: "Webhook",
    verb: "POST",
    path: "{merchant_url}",
    content: <ApiDocWebHook />,
  },
  {
    id: "confirm",
    title: "Confirm payment",
    verb: "PUT",
    path: "{base_url}/api/v1/payments/reference",
    content: <ApiDocConfirm />,
  },
];

const DocumentationPage = () => {
  const [expandedTab, setExpandedTab] = useState<string | null>(null);

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: "25px",
        overflow: "auto",
        maxHeight: {
          xs: `calc(var(--vvh) * 0.72 - env(safe-area-inset-top) - env(safe-area-inset-bottom))`,
          md: "86dvh",
        },
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Box sx={{ width: "96%", margin: "0 auto", pb: 3 }}>
        <PageHeader
          title="API docs"
          description="Integrate deposits, payouts and appeals with the Finzora API"
          icon={CodeOutlined}
        />

        {ENDPOINTS.map((endpoint) => (
          <EndpointCard
            key={endpoint.id}
            title={endpoint.title}
            verb={endpoint.verb}
            path={endpoint.path}
            expanded={expandedTab === endpoint.id}
            onToggle={() =>
              setExpandedTab(
                expandedTab === endpoint.id ? null : endpoint.id,
              )
            }
          >
            {endpoint.content}
          </EndpointCard>
        ))}
      </Box>
    </Box>
  );
};

export default DocumentationPage;
